import React, { useEffect } from "react";
import { motion } from "framer-motion";
import TopBannerSection from "@/components/homepage/TopBannerSection";
import HeroSection from "@/components/homepage/HeroSection";
import SuggestedListingsSection from "@/components/homepage/SuggestedListingsSection";
import CategoriesSection from "@/components/homepage/CategoriesSection";
import FeaturesSection from "@/components/homepage/FeaturesSection";
import HowItWorksSection from "@/components/homepage/HowItWorksSection";
import CallToActionSection from "@/components/homepage/CallToActionSection";
import AiAssistantSection from "@/components/homepage/AiAssistantSection";
import SellerBannerSection from "@/components/homepage/SellerBannerSection";
import HomepageSections from "@/components/homepage/HomepageSections";
import HowBuyersFindPartsSection from "@/components/homepage/HowBuyersFindPartsSection";
import FounderVendorBannerSection from "@/components/homepage/FounderVendorBannerSection";
import { openAuthDialog } from "../store/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const HomePageContent = ({ sectionsConfig }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  return (
    <motion.div
      className="flex flex-col gap-0 w-full"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <HomepageSections sections={sectionsConfig} />
    </motion.div>
  );
};

const HomePage = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();

  const sectionsConfig = [
    // {
    //   Component: FounderVendorBannerSection,
    //   key: "founder-vendor-banner",
    //   props: {},
    // },
    { Component: TopBannerSection, key: "top-banner", props: {} },
    { Component: AiAssistantSection, key: "ai-assistant-main", props: {} },
    { Component: SuggestedListingsSection, key: "suggested", props: {} },
    {
      Component: HowBuyersFindPartsSection,
      key: "how-buyers-find-parts",
      props: {},
    },
    { Component: SellerBannerSection, key: "seller-banner", props: {} },
    { Component: HeroSection, key: "hero", props: {} },
    { Component: CategoriesSection, key: "categories", props: {} },
    { Component: FeaturesSection, key: "features", props: {} },
    { Component: HowItWorksSection, key: "howitworks", props: {} },
    { Component: CallToActionSection, key: "cta", props: {} },
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const authRedirect = params.get("authRedirect");

    if (authRedirect && !isAuthenticated) {
      dispatch(
        openAuthDialog({
          showLoginFirstOrOnSuccess: true,
          redirectPage: window.location.pathname,
          onSuccessfulAuth: null,
          defaultTabOverride: "login",
        }),
      );

      // Remove param from URL without reloading page
      params.delete("authRedirect");
      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: true },
      );
    }
  }, [dispatch, isAuthenticated, location, navigate]);

  return <HomePageContent sectionsConfig={sectionsConfig} />;
};

export default HomePage;
